<template>
  <section class="container">
    <el-carousel height="270px" indicator-position="outside">
      <el-carousel-item class="banner">
        <img :src="banner1" width="100%">
      </el-carousel-item>
      <div class="headerFont">
        <span class="headerFontOne">魅力城轨 &nbsp;  美丽徐州</span><br>
        <span class="headerFontTwo">致力于打造 “最可信赖的公共交通服务者和最具活力的城市发展建设者” 。</span>
      </div>
    </el-carousel>
    <el-row>
      <el-col :span="16" :offset="4">
        <div :style="{'min-height': bgHeight}" class="resume-success-bg">
          <img :src="img2">
          <div :style="{backgroundImage: 'url(' + img3 + ')' }" class="profile">
            <h2>公司介绍</h2>
            <div v-html="infor">
              &nbsp;
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import Banner1 from 'assets/PC/banner_qyjs.png'
import img2 from 'assets/PC/image_qyjs_3.png'
import img3 from 'assets/PC/image2_qyjs.png'
import { getCompanyInfor } from 'api/recruit'
export default {
  data: () => {
    return {
      banner1: Banner1,
      img2: img2,
      img3: img3,
      infor: null,
      bgHeight: '300px'
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        let he = document.body.clientHeight - 65 - 270 - 60 - 100
        if (he < 300) {
          he = 300
        }
        this.bgHeight = he + 'px'
      })()
    }
  },
  created() {
    this._getCompanyInfor()
    this.initHeight()
  },
  methods: {
    initHeight() {
      const he = document.body.clientHeight - 65 - 270 - 60 - 100
      this.bgHeight = he + 'px'
    },
    _getCompanyInfor() {
      getCompanyInfor().then(
        (data) => {
          this.infor = data.data[0].configValue
        }
      )
    }
  }

}
</script>
<style>
.resume-success-bg>img {
   height: auto;
   width: auto;
 }
  .el-carousel__indicators--outside {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/companyprofile/index.vue